export const environment = {
  production: false,
  backClient: 'https://api.rec.tipayconnect.com/client',
  backWallet: 'https://api.rec.tipayconnect.com/wallet',
  tipay: {
    address: 'Cité Touba Alamdies, Mamelle',
    phone: '+221778848201',
    email: 'contact@tipayconnect.com',
  },
  supportEmail: 'contact@tipayconnect.com',
  supportPhone: '+221778848201',
  supportWhatsapp: '+221778848201',
};
